import request from '@/utils/request'

// 登录
export function login(params) {
	return request({
		url: 'index/index/userlogin',
		method: 'post',
		data: params, // 请求参数
	})
}
// 注册
export function register(params) {
	return request({
		url: 'index/index/register',
		method: 'post',
		data: params,
	})
}
//发送验证码
export function sendCode(params) {
	return request({
		url: 'index/index/sendtoemail',
		method: 'post',
		data: params,
	})
}
// 用户信息
export function userInfo(params) {
	return request({
		url: 'api/user/info',
		method: 'post',
		data: params,
	})
}
//课程
export function indexCourse(params) {
	return request({
		url: 'index/index/course',
		method: 'post',
		data: params,
	})
}
//首页小节列表
export function chapterlist(params) {
	return request({
		url: 'index/index/chapterlist',
		method: 'post',
		data: params,
	})
}
//小小节列表
export function chapterlists(params) {
	return request({
		url: 'index/index/chapterlists',
		method: 'post',
		data: params,
	})
}
//文档
export function getdocumentlist(params) {
	return request({
		url: 'index/index/getdocumentlist',
		method: 'post',
		data: params,
	})
}
//视频详情

//文件下载
export function download(params) {
	return request({
		url: 'index/index/download',
		method: 'post',
		data: params,
	})
}
//视频下载
export function downloadLargeFile(params) {
	return request({
		url: 'index/index/downloadLargeFile',
		method: 'post',
		data: params,
	})
}
